import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "environments/environment.staging";
import { User, Role } from "app/auth/models";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  //public
  public currentUser: Observable<User>;

  //private
  private currentUserSubject: BehaviorSubject<User>;
  private authUrl = `${environment.authApi}?key=${environment.authKey}`;

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */

  constructor(
    private _http: HttpClient,
    private _toastrService: ToastrService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return (
      this.currentUser && this.currentUserSubject.value.role === Role.Admin
    );
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return (
      this.currentUser && this.currentUserSubject.value.role === Role.Client
    );
  }

  /**
   * User login
   *
   * @param email
   * @param password
   * @returns user
   */
  login(email: string, password: string) {
    
    return this._http
      .post<any>(this.authUrl, { email, password, returnSecureToken: true })
      .pipe(
        map((response) => {
          console.log("API Response:", response); // Debugging

          if (response && response.idToken) {
            const user = {
              email: response.email,
              token: response.idToken,
              refreshToken: response.refreshToken,
              expiresIn: response.expiresIn,
              password: password,
            };

            localStorage.setItem("currentUser", JSON.stringify(user));
            this.currentUserSubject.next(user);
            this._toastrService.success(
              `Successful Login! Welcome ${user.email.split("@")[0]}`
            );
          } else {
            console.error("Error: No token received from API");
          }

          return response;
        })
      );
  }

  /**
   * User logout
   *
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    // notify
    this.currentUserSubject.next(null);
  }
}
